import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    invoices: [],
    invoiceMetaData: {},
    payments: [],
    paymentMetadata: {},
}

const MyAccountReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_INVOICES:
            return { ...state, ...action.payload }
        case ClientActionTypes.GET_PAYMENTS:
            return { ...state, ...action.payload }
        default:
            return { ...state }
    }
}

export default MyAccountReducer
